// Category imagery (WebP derived from the PNG masters in /public/img/src).
const WIDTHS = [480, 800, 1200, 1672];

export const CATEGORY_IMAGES = {
  pharmaceuticals: { file: "01_stige_pharmaceuticals", max: 1448, ratio: 1448 / 1086, mobile: "78% 50%" },
  nutraceuticals: { file: "02_stige_nutraceuticals", max: 1672, ratio: 1672 / 941, mobile: "92% 45%" },
  "medical-devices": { file: "03_stige_medical_devices", max: 1672, ratio: 1672 / 941, mobile: "62% 45%" },
  "medical-consumables": { file: "04_stige_medical_consumables", max: 1672, ratio: 1672 / 941, mobile: "88% 50%" },
  "herbal-products": { file: "05_stige_herbal_products", max: 1672, ratio: 1672 / 941, mobile: "70% 60%" },
  "ayurvedic-products": { file: "06_stige_ayurvedic_products", max: 1672, ratio: 1672 / 941, mobile: "88% 55%" },
};

export const CategoryImage = ({ id, alt, sizes, eager = false, position, className = "", testid }) => {
  const img = CATEGORY_IMAGES[id];
  if (!img) return null;
  const widths = [...WIDTHS.filter((w) => w < img.max), img.max];
  return (
    <img
      src={`/img/${img.file}-800.webp`}
      srcSet={widths.map((w) => `/img/${img.file}-${w}.webp ${w}w`).join(", ")}
      sizes={sizes}
      alt={alt || ""}
      loading={eager ? "eager" : "lazy"}
      fetchPriority={eager ? "high" : undefined}
      decoding="async"
      width={img.max}
      height={Math.round(img.max / img.ratio)}
      style={position ? { objectPosition: position } : undefined}
      className={className}
      data-testid={testid}
    />
  );
};
